import * as tslib_1 from "tslib";
import { BaseModel } from '../_base/model.class';
var User = /** @class */ (function (_super) {
    tslib_1.__extends(User, _super);
    function User(_id, roles, userRoles, email, password, firstName, lastName, taxCode, address, phone, active, originalPassword, properties, updatedAt, updatedBy, createdAt, createdBy, videoSecurity, videoSecurityDate, hideHomePopup) {
        var _this = _super.call(this) || this;
        _this._id = _id;
        _this.roles = roles;
        _this.userRoles = userRoles;
        _this.email = email;
        _this.password = password;
        _this.firstName = firstName;
        _this.lastName = lastName;
        _this.taxCode = taxCode;
        _this.address = address;
        _this.phone = phone;
        _this.active = active;
        _this.originalPassword = originalPassword;
        _this.properties = properties;
        _this.updatedAt = updatedAt;
        _this.updatedBy = updatedBy;
        _this.createdAt = createdAt;
        _this.createdBy = createdBy;
        _this.videoSecurity = videoSecurity;
        _this.videoSecurityDate = videoSecurityDate;
        _this.hideHomePopup = hideHomePopup;
        _this.setRequiredFields([
            '_id',
            'roles',
            // 'userRoles',
            'email',
            'password',
            'firstName',
            'lastName',
            'taxCode',
            'address',
            'phone',
            'active',
            'originalPassword',
            'createdAt',
            'createdBy',
        ]);
        return _this;
    }
    /**
     * Check if user is active or not
     *
     * @since 1.0.0
     */
    User.prototype.isActive = function () {
        return this.active;
    };
    /**
     * Check if user has the original password
     *
     * @since 1.0.0
     */
    User.prototype.isOriginalPassword = function () {
        return this.originalPassword;
    };
    return User;
}(BaseModel));
export { User };
